import { Component, ChangeDetectionStrategy } from '@angular/core';
import {RouterLink} from '@angular/router';
import {AuthService} from '../../services/auth.service';

@Component({
  selector: 'app-archive',
    imports: [
        RouterLink
    ],
  templateUrl: './archive.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './archive.component.scss'
})
export class ArchiveComponent {

  constructor(
    public authService: AuthService
  ) { }
}
